/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirmpassword1Inputs */

const en_confirmpassword1 = /** @type {(inputs: Confirmpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Password`)
};

const de_confirmpassword1 = /** @type {(inputs: Confirmpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm Password" |
*
* @param {Confirmpassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmpassword1 = /** @type {((inputs?: Confirmpassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmpassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmpassword1(inputs)
	return de_confirmpassword1(inputs)
});
export { confirmpassword1 as "confirmPassword" }